import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Paper, Divider, Grid } from "@material-ui/core";
import { baseWindowStyles } from "../../styles/styles";
import { getNumberFormat, getNumberFormatWithComma } from "../../utils/enums";
import { connect } from "react-redux";
import CountDown from "./CountDown";

import { updateUnsuccessMsg } from "../../store/unsuccess/actions";
import { getTransferContent } from "../../utils/transferContent";

import { useHistory } from "react-router-dom";

function Basket(props) {
  const classes = baseWindowStyles();

  const [time, setTime] = useState(60);
  const [timer, setTimer] = useState();

  const [processTimeout, setProcessTimeOut] = useState(false);
  const [totalRefundAmount, setTotalRefundAmount] = useState(0);

  const tarifeePrice = useMemo(() => {
    if (props.processContext.tarifeePrice) {
      return getNumberFormat(props.processContext.tarifeePrice);
    }
  }, [props.processContext.tarifeePrice]);
  const insurancePrice = useMemo(() => {
    if (props.processContext.insurancePrice) {
      return getNumberFormat(props.processContext.insurancePrice);
    }
  }, [props.processContext.insurancePrice]);
  const limitAllocationCommAmount = useMemo(() => {
    if (Number(props.processContext.limitAllocationCommAmount) > 0) {
      return getNumberFormat(props.processContext.limitAllocationCommAmount);
    }
  }, [props.processContext.limitAllocationCommAmount]);

  const amount = useMemo(() => {
    if (props.processContext.amount) {
      return getNumberFormat(props.processContext.amount);
    }
  }, [props.processContext.amount]);

  const sumCreditAmount = useMemo(() => {
    if (props.processContext.sumCreditAmount) {
      return getNumberFormat(props.processContext.sumCreditAmount);
    }
  }, [props.processContext.sumCreditAmount]);

  const installmentAmount = useMemo(() => {
    if (props.processContext.paymentPlan) {
      return getNumberFormat(
        props.processContext.paymentPlan?.at(-1)?.installmentAmount
      );
    }
  }, [props.processContext.paymentPlan]);

  let history = useHistory();

  useEffect(() => {
    if (props.processContext.urlExpireDate) {
      setTime(() => {
        return parseInt(
          (props.processContext.urlExpireDate - new Date().getTime()) / 1000
        );
      });
      startTimer();
    }
    return () => {
      setTime(60);
      setTimer(null);
    };
  }, []);

  useEffect(() => {
    if (processTimeout) {
      props.dispatch(updateUnsuccessMsg("İşlem Süreniz Doldu!"));
      history.push("/timeout");
    }
  }, [processTimeout]);

  useEffect(() => {
    if (props.processContext.refundAmount) {
      let total = 0;
      console.log(props.processContext);

      total += parseFloat(props.processContext.refundAmount);

      if (props.processContext.insurancePrice) {
        if (props.processContext.showInsuranceFlag === "1") {
          console.log("showInsuranceFlag = 1 e girdi");
          total += parseFloat(props.processContext.remainingInsuranceAmount);
        } else {
          console.log("showInsuranceFlag = 0 a girdi");
          total += parseFloat(props.processContext.insurancePrice);
        }
      }

      if (props.processContext.tarifeePrice) {
        total += parseFloat(props.processContext.tarifeePrice);
      }

      if (Number(props.processContext.limitAllocationCommAmount) > 0) {
        total += parseFloat(props.processContext.limitAllocationCommAmount);
      }
      setTotalRefundAmount(getNumberFormat(total + ""));
    }
  }, [
    props.processContext.refundAmount,
    props.processContext.insurancePrice,
    props.processContext.tarifeePrice,
    props.processContext.limitAllocationCommAmount,
    props.processContext.remainingInsuranceAmount,
    props.processContext.showInsuranceFlag,
  ]);

  const startTimer = () => {
    const timer = setInterval(() => {
      setTime((prevState) => {
        if (prevState <= 0) {
          stopTimer();

          return 0;
        } else {
          return prevState - 1;
        }
      });
    }, 1000);

    setTimer(timer);
  };
  const stopTimer = () => {
    setTimer((prevState) => {
      clearInterval(prevState);
      return null;
    });
    setProcessTimeOut(true);
  };

  return (
    <Paper className={classes.basket}>
      <h2 className={classes.basketCountDown}>
        <CountDown time={time} countDownStyle={classes.basketCountDown} />
      </h2>
      <h2 className={classes.basketHeader}>
        {props.processContext?.companyName && props.processContext?.companyName !== "" ? props.processContext?.companyName : props.processContext?.companyCode}
      </h2>
      <p className={classes.basketHeaderBottom}>
        {getTransferContent(props.processContext.doTransferToCompany).basketMessage}
      </p>
      <Divider className={classes.divider} />

      {props.processContext.paymentPlan && (
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.basketContentTitle}>Kredi Türü</div>
            <div className={classes.basketContentValue}>
              {props.processContext?.limitType === "TTK"
                ? "Ticari Taksitli Kredi"
                : props.processContext?.limitType}
            </div>
          </Grid>
          <Grid item xs={12}>
            <Divider className={classes.divider} />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.basketContentTitle}>Aylık Ödeme</div>
            <div className={classes.basketContentValue}>
              {props.processContext.paymentPlan?.at(-1).id +
                " x " +
                installmentAmount}
            </div>
          </Grid>
          <Grid item xs={12}>
            <Divider className={classes.divider} />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.basketContentTitle}>Toplam Geri Ödeme</div>
            <div className={classes.basketContentValue}>
              {totalRefundAmount}
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.basketContentSubTitle}>Kredi Tutarı</div>
            <div className={classes.basketContentSubValue}>{sumCreditAmount}</div>
          </Grid>
          {props.processContext.insurancePrice && (
            <Grid item xs={12}>
              <div className={classes.basketContentSubTitle}>Sigorta</div>
              <div className={classes.basketContentSubValue}>
                {insurancePrice}
              </div>
            </Grid>
          )}
          {props.processContext.tarifeePrice && (
            <Grid item xs={12}>
              <div className={classes.basketContentSubTitle}>Tarife</div>
              <div className={classes.basketContentSubValue}>
                {tarifeePrice}
              </div>
            </Grid>
          )}
          {Number(props.processContext.limitAllocationCommAmount) > 0 && (
            <Grid item xs={12}>
              <div className={classes.basketContentSubTitle}>
                Kredi Tahsis Ücreti
              </div>
              <div className={classes.basketContentSubValue}>
                {limitAllocationCommAmount}
              </div>
            </Grid>
          )}

          <Grid item xs={12}>
            <Divider className={classes.divider} />
          </Grid>
        </Grid>
      )}

      <div className={classes.basketAmountTitle}>
        {props.processContext.doTransferToCompany === "0"
          ? "Kredi Tutarı"
          : "Sepet Tutarı"}
      </div>
      <div className={classes.basketAmount}>
        {amount}
        <sup className={classes.basketSup}>TL</sup>
      </div>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    processContext: state.processContext,
  };
};

export default connect(mapStateToProps)(Basket);
